<span class="ant-divider-inner-text" *ngIf="nzText">
  <ng-container *nzStringTemplateOutlet="nzText">{{ nzText }}</ng-container>
</span>
